export default __webpack_public_path__ + "static/media/portfolio_video1.847dd54f.mp4";